module.exports = __webpack_public_path__ + "img/roll-680.6d7c24d9.png";